import type {FunctionComponent} from 'react';
import {useTranslation} from '@app/hooks/use-translation';
import {LandingHeading, LandingParagraph} from '@tempo/landing';
import {Image} from '@app/components/Image';
import {LandingButtonLink} from '@app/components/landing-btn-link';
import type {LocalImageConfig} from '@app/hooks/use-local-image';
import {useLocalImage} from '@app/hooks/use-local-image';

import {LandingIllustrationSection} from '@app/components/layout/LandingIllustrationSection';

const IMAGE_CONFIG: LocalImageConfig = {
	default: 'cbe2daf8bb8dc90da76b44f903e3698d.png',
	fr: '518b41fea2f6ad191faad973dfc8713f.png',
};

export const Song: FunctionComponent = () => {
	const {t} = useTranslation();
	const src = useLocalImage(IMAGE_CONFIG);
	return (
		<LandingIllustrationSection
			description={
				<>
					<LandingHeading as="h2">
						{t('musicquizlandingpage_title_songbasedquizzes_standalone-web', {
							ns: 'musicquiz',
						})}
					</LandingHeading>
					<LandingParagraph>
						{t('musicquizlandingpage_text_songbasedquizzes_standalone-web', {
							ns: 'musicquiz',
						})}
					</LandingParagraph>
				</>
			}
			image={
				<Image
					objectFit={{base: 'cover', sm: 'contain'}}
					quality={90}
					src={src}
					aspectRatio="1440/420"
					alt={t('generic_action_playnow_standalone-web', {ns: 'common'})}
				/>
			}
			cta={
				<LandingButtonLink
					tracking={{
						eventaction: 'discover-channel-game',
						eventlabel: 'section2',
					}}
					href="https://link.deezer.com/?dest=https%3A%2F%2Fwww.deezer.com%2Fchannels%2Fgames%3Fbypassreferer%3D1&amv=8.0.12&imv=10.12.0"
				>
					{t('generic_action_tryitnowfeature_standalone-web', {ns: 'common'})}
				</LandingButtonLink>
			}
		/>
	);
};
